import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {map, Observable} from 'rxjs';
import {EntityCostReport} from '../model/skucost/entity-cost-report';
import {AutoCostReport} from '../model/autocost/auto-cost-report';

@Service()
export class SkuCostService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'skuCost/';

  getCostReport(entityId: string, revision: number): Observable<EntityCostReport> {
    const url = this.urlBase + 'entityCostReport/' + entityId + '/' + revision;
    return this.http.get<EntityCostReport>(url, {headers: this.getRequestHeaders()});
  }

  getAutoCostReport(entityId: string, revision: number): Observable<AutoCostReport> {
    const url = this.urlBase + 'autoCost/report/' + entityId + '/' + revision;
    return this.http.get<AutoCostReport>(url, {headers: this.getRequestHeaders()});
  }

  exportCostReport(entityId: string, revision: number): Observable<Blob> {
    const url = this.urlBase + 'entityCostReportExport/' + entityId + '/' + revision;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
